import { legacy_createStore as createStore, applyMiddleware, Store } from 'redux';
import rootReducer from './reducers/rootReducer';

const logger = require("redux-logger");
const store: Store = process.env.NODE_ENV === 'production' ?  createStore(rootReducer) :  createStore(
    rootReducer,
    applyMiddleware(logger.createLogger())
);

export default store;
